import { Job } from '~hooks/useJob/models';

import { JobDetailsContainer } from '../JobDetailsContainer';

interface JobsTableExpandedBlockProps {
  job: Job;
  readOnly: boolean;
}

export default function JobsTableExpandedBlock({
  job,
  readOnly,
}: JobsTableExpandedBlockProps) {
  return <JobDetailsContainer details={job} readOnly={readOnly} />;
}
